
/**
 * A single share button. This is usually not exposed, but is a
 * sub-component of {@link ShareButtons}
 * @module shareItem
 * @version 1.1
 */

import * as React from 'react';

import { displayTypes } from './displayTypes';
import { socialNetworkNameReplacement } from './socialNetworkNameReplacement';

/**
 * Share count number is only being shown if greater than this constant.
 * @const {number}
 */
var minimumShares = 30;

function shareCountFormatter(count) {
  return count >= minimumShares ? count : '';
}

/**
 * A share item is a single sharing item, consisting of a link with an icon.
 * Using display types, this item can be displayed in different ways, either
 * as a list item or as a button.
 *
 * @param {ShareItemProps} props
 */
export function ShareItem(_ref) {
  var displayType = _ref.displayType,
      _ref$inverted = _ref.inverted,
      inverted = _ref$inverted === undefined ? false : _ref$inverted,
      type = _ref.type,
      count = _ref.count,
      description = _ref.description,
      shareUrl = _ref.shareUrl,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function (event) {} : _ref$onClick,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var itemClass = type + ' ' + (inverted ? 'inverted' : '') + ' ' + className + ' share';
  var innerText = void 0;

  switch (displayType) {
    case displayTypes.HORIZONTAL_ICONS:
      itemClass = itemClass + ' item';
      innerText = shareCountFormatter(count);
      break;

    case displayTypes.VERTICAL_BUTTONS:
      itemClass = className + ' ' + (inverted ? 'inverted' : '') + ' ui button share';
      innerText = description;
      break;

    case displayTypes.HORIZONTAL_BUTTONS:
      itemClass = socialNetworkNameReplacement[type] + ' ' + className + ' ui icon button share';
      innerText = shareCountFormatter(count);
      break;
  }

  return React.createElement(
    'a',
    {
      href: shareUrl,
      title: description,
      className: itemClass,
      onClick: onClick,
      target: '_top'
    },
    React.createElement('i', { className: socialNetworkNameReplacement[type] + ' icon' }),
    innerText
  );
}

export default ShareItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-share-buttons/es/shareItem.js
// module id = 77
// module chunks = 0